import React, {Component} from 'react';
import {ProSidebar, Menu, MenuItem, SubMenu, SidebarFooter, SidebarHeader, SidebarContent} from 'react-pro-sidebar';
import "@fortawesome/react-fontawesome";
import './sidebar.scss';
import {request} from "../../helper/APIUtils";
import {Link} from "react-router-dom";
import {SERVLET_PATH} from "../../constants";

class ServiceDocSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: false,
            serviceDocumentation: {
                docList: [],
                time: null
            }


        }
        this.handleClickCollapse = this.handleClickCollapse.bind(this);
    }

    componentDidMount() {
        this.getEndpoint();
    }
    componentWillReceiveProps = (nextProps)=> {
        this.setState({serviceDocumentation: nextProps.serviceDocumentation});
    }

    getEndpoint() {

        let self = this;
        let params = {
            url: "/servicedocumentation/findAllDocumentationDto",
            method: "get"
        };
        request(params)
            .then(function (response) {
                let serviceDocumentation = response.data;
                self.setState({serviceDocumentation: serviceDocumentation});
                self.props.setServiceDocumentation(serviceDocumentation);
            });
    }
    handleClickCollapse() {
        let navbarTitle = document.getElementById("navbarTitle")

        if(this.state.isCollapsed){
            this.setState({isCollapsed: false})
            navbarTitle.style.display ="inline-block";

        }else{
            this.setState({isCollapsed: true})
            navbarTitle.style.display ="none";
        }

    }
    handleClickMenuItem = (id,e) => {
        const selectedListItem = document.getElementById(id);
        const oldSelectedItem = document.getElementsByClassName('navbar-selected-item')[0];
        if(oldSelectedItem!=null){
            oldSelectedItem && oldSelectedItem.classList.remove('navbar-selected-item')
        }
        selectedListItem.classList.add('navbar-selected-item');
        this.props.callback(id);
    }

    isEFatura() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EFATURA;
    }
    isEArsiv() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIV;
    }
    isEDefter() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTER;
    }
    isEDefterSaklama() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTERSAKLAMA;
    }
    isEIrsaliye() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EIRSALIYE;
    }
    isEMM() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EMM;
    }
    isESMM() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.ESMM;
    }
    isEGiderPusulasi(){
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EGIDERPUSULASI;
    }

    render() {
        return (
            <ProSidebar collapsed={this.state.isCollapsed ? "collapsed" : ""}>
                <SidebarHeader>
                    <div className="doc-navbar-title">
                        <Link to="/serviceDocumentation" className="simple-text" id="navbarTitle">
                            DOKÜMANTASYON
                        </Link>
                    </div>
                </SidebarHeader>
                <SidebarContent>
                    <Menu iconShape="circle">
                        <MenuItem icon={<i className="fas fa-home"></i>}>Portal<Link to="/homePage/"/></MenuItem>
                        {this.props.currentUser && this.state.serviceDocumentation &&this.state.serviceDocumentation.length>0 && this.state.serviceDocumentation.map((data) =>{
                            if(data.isActive == true && data.name=="E-Fatura" && this.isEFatura()){
                                return (
                                    <SubMenu key="E-Fatura" icon={<i className="fas fa-file-alt"></i>} title={data.name}>
                                        {data.sections.map((sectionData) =>
                                            (sectionData.isActive == true &&
                                                <SubMenu key={sectionData.name} id={sectionData.name} title={sectionData.name}>
                                                    {sectionData.endpoint.map(menuData =>
                                                        (menuData.isActive == true &&
                                                            <MenuItem key={menuData.recordId} id={menuData.recordId}
                                                                      onClick={(e) => this.handleClickMenuItem(menuData.recordId,e)}>{menuData.name}<Link
                                                                to="/serviceDocumentation/"/></MenuItem>
                                                        ))} </SubMenu>
                                            ))}
                                    </SubMenu>
                                )
                            }else if(data.isActive == true && data.name=="E-Arşiv" && this.isEArsiv()){
                                return (
                                    <SubMenu key="E-Arşiv" icon={<i className="fas fa-file-alt"></i>} title={data.name}>
                                        {data.sections.map((sectionData) =>
                                            (sectionData.isActive == true &&
                                                <SubMenu key={sectionData.name} id={sectionData.name} icon={<i className="fas fa-file-alt"></i>}
                                                         title={sectionData.name}>
                                                    {sectionData.endpoint.map(menuData =>
                                                        (menuData.isActive == true &&
                                                            <MenuItem key={menuData.recordId} id={menuData.recordId}
                                                                      onClick={(e) => this.handleClickMenuItem(menuData.recordId)}>{menuData.name}<Link
                                                                to="/serviceDocumentation/"/></MenuItem>
                                                        ))} </SubMenu>
                                            ))}
                                    </SubMenu>
                                )
                            }else if(data.isActive == true && data.name=="E-Defter" && this.isEDefter()){
                                return (
                                    <SubMenu key="E-Defter" icon={<i className="fas fa-file-alt"></i>} title={data.name}>
                                        {data.sections.map((sectionData) =>
                                            (sectionData.isActive == true &&
                                                <SubMenu key={sectionData.name} id={sectionData.name} icon={<i className="fas fa-file-alt"></i>}
                                                         title={sectionData.name}>
                                                    {sectionData.endpoint.map(menuData =>
                                                        (menuData.isActive == true &&
                                                            <MenuItem key={menuData.recordId} id={menuData.recordId}
                                                                      onClick={(e) => this.handleClickMenuItem(menuData.recordId)}>{menuData.name}<Link
                                                                to="/serviceDocumentation/"/></MenuItem>
                                                        ))} </SubMenu>
                                            ))}
                                    </SubMenu>
                                )
                            }else if(data.isActive == true && data.name=="E-Defter Saklama" && this.isEDefterSaklama()){
                                return (
                                    <SubMenu key="E-Defter Saklama" icon={<i className="fas fa-file-alt"></i>} title={data.name}>
                                        {data.sections.map((sectionData) =>
                                            (sectionData.isActive == true &&
                                                <SubMenu key={sectionData.name} id={sectionData.name} icon={<i className="fas fa-file-alt"></i>}
                                                         title={sectionData.name}>
                                                    {sectionData.endpoint.map(menuData =>
                                                        (menuData.isActive == true &&
                                                            <MenuItem key={menuData.recordId} id={menuData.recordId}
                                                                      onClick={(e) => this.handleClickMenuItem(menuData.recordId)}>{menuData.name}<Link
                                                                to="/serviceDocumentation/"/></MenuItem>
                                                        ))} </SubMenu>
                                            ))}
                                    </SubMenu>
                                )
                            }else if(data.isActive == true && data.name=="E-İrsaliye" && this.isEIrsaliye()){
                                return (
                                    <SubMenu key="E-İrsaliye" icon={<i className="fas fa-file-alt"></i>} title={data.name}>
                                        {data.sections.map((sectionData) =>
                                            (sectionData.isActive == true &&
                                                <SubMenu key={sectionData.name} id={sectionData.name} icon={<i className="fas fa-file-alt"></i>}
                                                         title={sectionData.name}>
                                                    {sectionData.endpoint.map(menuData =>
                                                        (menuData.isActive == true &&
                                                            <MenuItem key={menuData.recordId} id={menuData.recordId}
                                                                      onClick={(e) => this.handleClickMenuItem(menuData.recordId)}>{menuData.name}<Link
                                                                to="/serviceDocumentation/"/></MenuItem>
                                                        ))} </SubMenu>
                                            ))}
                                    </SubMenu>
                                )
                            }else if(data.isActive == true && data.name=="E-Müstahsil" && this.isEMM()){
                                return (
                                    <SubMenu key="E-Müstahsil" icon={<i className="fas fa-file-alt"></i>} title={data.name}>
                                        {data.sections.map((sectionData) =>
                                            (sectionData.isActive == true &&
                                                <SubMenu key={sectionData.name} id={sectionData.name} icon={<i className="fas fa-file-alt"></i>}
                                                         title={sectionData.name}>
                                                    {sectionData.endpoint.map(menuData =>
                                                        (menuData.isActive == true &&
                                                            <MenuItem key={menuData.recordId} id={menuData.recordId}
                                                                      onClick={(e) => this.handleClickMenuItem(menuData.recordId)}>{menuData.name}<Link
                                                                to="/serviceDocumentation/"/></MenuItem>
                                                        ))} </SubMenu>
                                            ))}
                                    </SubMenu>
                                )
                            }else if(data.isActive == true && data.name=="E-Serbest Meslek" && this.isESMM()){
                                return (
                                    <SubMenu key="E-Serbest Meslek" icon={<i className="fas fa-file-alt"></i>} title={data.name}>
                                        {data.sections.map((sectionData) =>
                                            (sectionData.isActive == true &&
                                                <SubMenu key={sectionData.name} id={sectionData.name} icon={<i className="fas fa-file-alt"></i>}
                                                         title={sectionData.name}>
                                                    {sectionData.endpoint.map(menuData =>
                                                        (menuData.isActive == true &&
                                                            <MenuItem key={menuData.recordId} id={menuData.recordId}
                                                                      onClick={(e) => this.handleClickMenuItem(menuData.recordId)}>{menuData.name}<Link
                                                                to="/serviceDocumentation/"/></MenuItem>
                                                        ))} </SubMenu>
                                            ))}
                                    </SubMenu>
                                )
                            }else if(data.isActive == true && data.name=="E-Gider Pusulası" && this.isEGiderPusulasi()){
                                return (
                                    <SubMenu key="E-Gider Pusulası" icon={<i className="fas fa-file-alt"></i>} title={data.name}>
                                        {data.sections.map((sectionData) =>
                                            (sectionData.isActive == true &&
                                                <SubMenu key={sectionData.name} id={sectionData.name} icon={<i className="fas fa-file-alt"></i>}
                                                         title={sectionData.name}>
                                                    {sectionData.endpoint.map(menuData =>
                                                        (menuData.isActive == true &&
                                                            <MenuItem key={menuData.recordId} id={menuData.recordId}
                                                                      onClick={(e) => this.handleClickMenuItem(menuData.recordId)}>{menuData.name}<Link
                                                                to="/serviceDocumentation/"/></MenuItem>
                                                        ))} </SubMenu>
                                            ))}</SubMenu>
                                )
                            }
                            }
                        )}

                        {this.props.currentUser.customerId==1 &&
                            <MenuItem icon={<i className="far fa-edit"></i>}>
                                <Link to="/serviceDocumentation/add"/>
                                Doküman Ekle
                            </MenuItem>
                        }

                        <SubMenu title="Servisler" icon={<i className="fas fa-code"></i>}>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/cancelDocument?serviceType=SOAP">
                                        cancelDocument
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/createLink?serviceType=SOAP">
                                        createLink
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/customerCredit?serviceType=SOAP">
                                        customerCredit
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/getCreditActions?serviceType=SOAP">
                                        getCreditActions
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/getGibUser?serviceType=SOAP">
                                        getGibUser
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/getPrefixCodeList?serviceType=SOAP">
                                        getPrefixCodeList
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/getXsltList?serviceType=SOAP">
                                        getXsltList
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/gibUserListAsJson?serviceType=SOAP">
                                        gibUserListAsJson
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/lastDocumentNumber?serviceType=SOAP">
                                        lastDocumentNumber
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/loadDocument?serviceType=SOAP">
                                        loadDocument
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/objectDocument?serviceType=SOAP">
                                        objectDocument
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/queryContent?serviceType=SOAP">
                                        queryContent
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/queryDocumentList?serviceType=SOAP">
                                        queryDocumentList
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/queryDocumentListGUID?serviceType=SOAP">
                                        queryDocumentListGUID
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/queryLoadContent?serviceType=SOAP">
                                        queryLoadContent
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/queryLoadDocument?serviceType=SOAP">
                                        queryLoadDocument
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/queryLoadDocumentList?serviceType=SOAP">
                                        queryLoadDocumentList
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/sendAppResponse?serviceType=SOAP">
                                        sendAppResponse
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/sendDocument?serviceType=SOAP">
                                        sendDocument
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/sendDocumentModel?serviceType=SOAP">
                                        sendDocumentModel
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/sendDocumentResponse?serviceType=SOAP">
                                        sendDocumentResponse
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/setDocumentFlag?serviceType=SOAP">
                                        setDocumentFlag
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <Link to="/serviceDocumentation/method/setTakenFromEntegrator?serviceType=SOAP">
                                        setTakenFromEntegrator
                                    </Link>
                                </MenuItem>
                        </SubMenu>
                    </Menu>
                </SidebarContent>
                <SidebarFooter>
                    <div className="sidebar-footer"></div>
                </SidebarFooter>
            </ProSidebar>
        );
    }
}

export default ServiceDocSidebar;
